import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailers-opt_in_nudge_sign_up_cta-success';

/**
 * Track successful user email sign-up upon clicking the "Sign Up" CTA, within the opt-in nudge surfaces. The "Origin" parameter below will return either "POPUP_PROMPT", "POST_ORDER_PRIMARY", "POST_ORDER_SECONDARY", or "FOOTER_PAGE"
 */
export function trackRetailersOptInNudgeSignUpCtaSuccess(
  Origin_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Origin_string },
  });
}
